import { render, staticRenderFns } from "./SysChannelModal.vue?vue&type=template&id=e596380e&"
import script from "./SysChannelModal.vue?vue&type=script&lang=js&"
export * from "./SysChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports